// Unique code to get top level Page Component and Page SCSS
// The only thing different is the from part should match your component

// All boilerplate cut/paste stuff
import ReactDOM from 'react-dom/client';
import React from 'react';
import PAGE_COMPONENT from './UserProfileV2';
import { Provider as PAGE_CONTEXT } from '../../../contexts/PageContext';

// eslint-disable-next-line no-undef
const props = globalPageProps || {};

ReactDOM.hydrateRoot(
    document.getElementById('root'),
    <PAGE_CONTEXT PAGE_PROPS={props.PAGE_PROPS}>
        <PAGE_COMPONENT {...props} />
    </PAGE_CONTEXT>
);

// TO USE THIS COMPONENT IN THE BACKEND:

/**
 
*  To render the component:
*
*  req.reactRender = {
*      componentPath: 'UserProfileV2/UserProfileV2,
*      props: {},
*      metaTagData:{}
*  }
*
*  next();
*  return;
*

 */
